import React from "react";
import { Paper, Box, useTheme } from "@mui/material";
import UserGeneratedMessage from "../components/UserGeneratedMessage";
import SystemGeneratedMarkdown from "../components/SystemGeneratedMarkdown";
import D3HeatMapShell from "../components/D3HeatMapShell";
import D3Chart from "../components/D3Chart";
import UserGeneratedCodeMessage from "../components/UserGeneratedCodeMessage";
import UserGeneratedMessageWithContext from "../components/UserGeneratedMessageWithContext";

const MessageRenderer = ({ message, index }) => {
    const theme = useTheme();

    const fadeInStyles = {
        animation: "fadeIn 0.15s ease-in",
        "@keyframes fadeIn": {
            from: { opacity: 0 },
            to: { opacity: 1 },
        },
    };

    const containerStyles = {
        alignContent: "center",
        marginTop: 2,
        marginBottom: 2,
        minHeight: 100,
        borderRadius: "4px",
        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.15)",
        backgroundColor: theme.palette.background.paper,
        flexDirection: "column",
        padding: 2,
    };

    const paperStyles = {
        padding: 2,
        backgroundColor: theme.palette.background.paper,
    };

    if (message.role === "user") {
        switch (message.componentType) {
            case "text":
                return (
                    <Box key={index} sx={fadeInStyles}>
                        <UserGeneratedMessage text={message.content[0].text} iconType={message.icon} />
                    </Box>
                );
            case "text-with-context":
                return (
                    <Box key={index} sx={fadeInStyles}>
                        <UserGeneratedMessageWithContext context={message} text={message.content[0].text} iconType={message.icon} />
                    </Box>
                );
            case "code":
                return (
                    <Box key={index} sx={fadeInStyles}>
                        <UserGeneratedCodeMessage text={message.content[0].text} iconType={message.icon} />
                    </Box>
                );
            case "D3":
                return (
                    <Paper key={index} sx={paperStyles}>
                        <D3HeatMapShell config={message.payload.config} />
                    </Paper>
                );
            case "chart":
                return (
                    <Paper key={index} sx={paperStyles}>
                        {/* Replace with actual chart logic */}
                        <div>Placeholder for chart</div>
                    </Paper>
                );
            default:
                return null;
        }
    } else {
        switch (message.role) {
            case "assistant":
                switch (message.componentType) {
                    case "text":
                        return (
                            <Box key={index} sx={fadeInStyles}>
                                <SystemGeneratedMarkdown type="text" config={message} />
                            </Box>
                        );
                    case "chart":
                        return (
                            <Box key={index} sx={fadeInStyles}>
                                <Box sx={containerStyles}>
                                    <D3Chart config={message.content[0]} />
                                </Box>
                            </Box>
                        );
                    default:
                        return null;
                }
            case "error":
                return (
                    <Box key={index} sx={fadeInStyles}>
                        <SystemGeneratedMarkdown type="error" config={message} />
                    </Box>
                );
            default:
                return null;
        }
    }
};

export default MessageRenderer;
